import AxiosInstance from 'config/apiServiceApiGateway'
import axiosInstanceFileService from 'config/apiServiceFile'
import {
  GetPromotionTypeResponseInterface,
  GetReimbursementMethodQueryType,
  GetReimbursementMethodResponseInterface,
  CampaignClusterContentType,
  PostCreateSKPParamInterface,
  PostCreateSKPResponseInterface,
  PostCreateSKPCopyParamInterface,
  GetVendorDataResponseInterface,
  GetVendorListParamsInterface,
  GetVendorListResponseInterface,
  PutUpdateSKPInterface,
  PutUpdateSKPResponseInterface,
  GetSKPDetailResponseInterface,
  GetSKPVendorDiffInterface,
  GetBrandSubmissionCampaignResponseInterface,
  GetBrandSubmissionListsResponseInterface,
  ErrorObjectInterface,
} from 'features/Enterprise/SKP/@types/sourcingTypes'

export const getPromotionTypeAPI = () =>
  AxiosInstance.Get<GetPromotionTypeResponseInterface, true>({
    url: '/skp/internal/:version/promotion-types?environment=External',
    version: 'v1',
  })

export const getReimbursementMethodsAPI = (query: GetReimbursementMethodQueryType) =>
  AxiosInstance.Get<GetReimbursementMethodResponseInterface, true>({
    url: '/skp/internal/:version/reimbursement-methods',
    version: 'v1',
    params: query,
  })

export const getCampaignClusterAPI = () =>
  AxiosInstance.Get<{ data: { campaign_clusters: CampaignClusterContentType[] } }, true>({
    url: '/skp/internal/:version/campaign-clusters',
    version: 'v1',
  })

export const postCreateSKPAPI = (params: PostCreateSKPParamInterface) =>
  AxiosInstance.Post<PostCreateSKPResponseInterface, true>({
    url: '/commercial/internal/:version/skps',
    version: 'v2',
    data: params,
  })

export const postCopySKPAPI = (params: PostCreateSKPCopyParamInterface, skpId: number) =>
  AxiosInstance.Post<PostCreateSKPResponseInterface, true>({
    url: `/commercial/internal/:version/skps/${skpId}/copy`,
    version: 'v2',
    data: params,
  })

export const getVendorDataAPI = (vendor_id: number) =>
  AxiosInstance.Get<GetVendorDataResponseInterface, true>({
    url: `/skp/internal/:version/vendors/${vendor_id}`,
    version: 'v1',
  })

export const getVendorListAPI = (params: GetVendorListParamsInterface) =>
  AxiosInstance.Get<GetVendorListResponseInterface, true>({
    url: '/skp/internal/:version/vendors',
    version: 'v1',
    params,
  })

export const putUpdateSKPAPI = (params: PutUpdateSKPInterface, skpId: number) =>
  AxiosInstance.Put<PutUpdateSKPResponseInterface, true>({
    url: `/skp/internal/v3/skps/${skpId}`,
    data: params,
  })

export const getSKPDetailAPI = (skpId: number) =>
  AxiosInstance.Get<GetSKPDetailResponseInterface, true>({
    url: `/skp/internal/:version/skp/${skpId}`,
    version: 'v2',
  })

export const deleteSKPAPI = (skpId: string) =>
  AxiosInstance.Delete<{ message: string; error: ErrorObjectInterface }, true>({
    url: `/skp/internal/:version/skp/${skpId}`,
    version: 'v2',
  })

export const getSKPVendorDiffAPI = (skpId: number) =>
  AxiosInstance.Get<GetSKPVendorDiffInterface, true>({
    url: `/skp/internal/:version/skps/${skpId}/vendor/diff`,
    version: 'v1',
  })

// @TODO: properly define the response type
export const getDownloadSKPDetailsAPI = (skpId: number) =>
  AxiosInstance.Get<{ file_url: string; error: ErrorObjectInterface }, true>({
    url: `/commercial/internal/:version/skps/${skpId}/details/download`,
    version: 'v1',
  })

export const getDownloadSKPCampaignAPI = (skpId: number) =>
  AxiosInstance.Get<{ file_url: string; error: ErrorObjectInterface }, true>({
    url: `/commercial/internal/v1/skps/${skpId}/details/download/campaign`,
  })

export const getDownloadActualClaimAPI = (skpId: number) =>
  AxiosInstance.Get<{ file_url: string; error: ErrorObjectInterface }, true>({
    url: `/commercial/internal/v1/skps/${skpId}/actual-claims/download`,
  })

export const postUploadActualClaimFileAPI = (skpId: number, file_url: string) =>
  AxiosInstance.Post<{ file_url: string; message: string; error: ErrorObjectInterface }, true>({
    url: `/commercial/internal/v1/skps/${skpId}/actual-claims/upload`,
    data: { file_url },
  })

// @TODO: properly define the response type
export const postUploadSKPDetailFileAPI = (skpId: number, file_url: string) =>
  AxiosInstance.Post<{ file_url: string; message: string; error: ErrorObjectInterface }, true>({
    url: `/commercial/internal/:version/skps/${skpId}/details/upload`,
    version: 'v1',
    data: { file_url },
  })

export const postSKPStatusAPI = (skpId: number, status: string, rejectReason?: string) =>
  AxiosInstance.Post<{ message: string; error: ErrorObjectInterface }, true>({
    url: `/skp/internal/v3/skps/${skpId}/status/${status}`,
    data: { reject_reason: rejectReason || '' },
  })

export const getBrandSubmissionDetailAPI = (brandSubmissionId: number) =>
  AxiosInstance.Get<GetBrandSubmissionCampaignResponseInterface, true>({
    url: `/skp/internal/:version/brand-submissions/${brandSubmissionId}`,
    version: 'v1',
  })

export const getBrandSubmissionsListAPI = (name: string) =>
  AxiosInstance.Get<GetBrandSubmissionListsResponseInterface, true>({
    url: `/skp/internal/:version/brand-submission/search`,
    version: 'v1',
    params: { campaign_theme: name },
  })

export const getDeckPromotionFile = (fileUrl: string, type: string) =>
  axiosInstanceFileService.Get<Blob, true>({
    url: '/internal/:version/skp-brand-submission-attachment/download',
    version: 'v1',
    params: { fileUrl },
    config: {
      responseType: 'blob',
      transformResponse: (data) => new Blob([data], { type }),
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'X-Service-Name': 'astro-app-web-admin',
      },
    },
  })
